import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {IanaTimezone} from 'core/utils/timezone'
import authHeaders from './authHeaders'
import { IStudyReviewerResult } from './getStudyReviewer'

export interface ICreateTechnicians {
  emails: string[]
}

interface ICreateTechniciansResponseBody {
  technicians: IStudyReviewerResult[]
}

export interface ICreateTechniciansResponse extends AxiosResponse {
  data: ICreateTechniciansResponseBody
}

export function createTechnicians(token: string, reviewerId: string, data: ICreateTechnicians): Promise<ICreateTechniciansResponse> {
  const url = `/study/reviewer/${reviewerId}/technicians`;
  return Client.post(url, data, { ...authHeaders(token), validateStatus: () => true });
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/createTechnicians.ts